import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { MomentModule } from 'angular2-moment'

import { MaterialModule } from '../material/material.module'
import { DialogModule } from '../dialog/dialog.module'
import { GeolocationModule } from '../geolocation/geolocation.module'

import { NavigationToolbarComponent } from './navigation-toolbar/navigation-toolbar.component'
import { AvatarComponent } from './avatar/avatar.component'
import { AvatarCarouselComponent } from './avatar-carousel/avatar-carousel.component'

import { GroupByPipe } from './group-by.pipe'
import { ShowtimeTypePipe } from './showtime-type.pipe'
import { GracenoteAssetPipe } from './gracenote/gracenote-asset.pipe'
import { SpinnerComponent } from './spinner/spinner.component'
import { EmptyComponent } from './empty/empty.component'
import { EmptyTitleComponent } from './empty/empty-title/empty-title.component'
import { EmptyContentComponent } from './empty/empty-content/empty-content.component'
import { AdComponent } from './ad/ad.component'
import { ScheduleComponent } from './schedule/schedule.component'
import { FilterByDayPipe } from './filter-by-day/filter-by-day.pipe'
import { AgePipe } from './age/age.pipe'
import { DistancePipe } from './distance/distance.pipe'
import { AudioService, Sound } from './audio/audio.service'

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        MomentModule,
        TranslateModule,
        DialogModule,
        GeolocationModule,
    ],
    exports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        TranslateModule,
        DialogModule,
        GeolocationModule,
        MomentModule,
        NavigationToolbarComponent,
        AvatarComponent,
        AvatarCarouselComponent,
        GroupByPipe,
        ShowtimeTypePipe,
        GracenoteAssetPipe,
        SpinnerComponent,
        EmptyComponent,
        EmptyTitleComponent,
        EmptyContentComponent,
        ScheduleComponent,
        AdComponent,
        AgePipe,
        DistancePipe,
    ],
    declarations: [
        NavigationToolbarComponent,
        AvatarComponent,
        AvatarCarouselComponent,
        GroupByPipe,
        ShowtimeTypePipe,
        GracenoteAssetPipe,
        SpinnerComponent,
        EmptyComponent,
        EmptyTitleComponent,
        EmptyContentComponent,
        AdComponent,
        ScheduleComponent,
        FilterByDayPipe,
        AgePipe,
        DistancePipe,
    ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [AudioService]
    }
  }
}

export { AudioService, Sound }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/shared.module.ts